@use 'shared/styles/generated/tokens' as *;
@use 'shared/styles/mixins' as *;

.body {
  display: flex;
  flex-direction: column;
  gap: $space-small-l;
  // Высоту держит сама шторка (`size='TALL'`): она всегда во весь доступный максимум и не
  // дышит от того, что происходит в поиске — популярные, результаты, пустое состояние. Тело
  // просто занимает её целиком, а скролл живёт на Content (см. BottomSheet.module.scss).
  height: 100%;
}

.rows {
  display: flex;
  flex-direction: column;
  gap: $space-small-xs;
}

.row {
  display: flex;
  flex-direction: column;
  gap: $space-small-xs;
  width: 100%;
  padding: $space-small-m 0;
}

// Галочка у выбранного города: единственная индикация выбора в списке (правило 10 —
// красного тут быть не может, а фоновой заливки строки список не носит).
.check {
  flex: none;
  display: flex;
  color: $color-accent;
}

// Пустое состояние занимает всю освободившуюся высоту и центрируется в ней — иначе
// иллюстрация прижималась к поиску, а под ней зияла пустая шторка.
.empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
